import React from "react";
import { PropTypes } from "prop-types";
import { MrbPageContentHeader } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { MrbQuerySearchInput } from "mrb/components/input";
import { TableNoDataOverlay } from "common/components";
import { observer } from "mobx-react";
import { AppReleaseLatestVersionTemplate } from "themes/administration/app-release/components";

function AppReleaseRowActions({ actions, item, t }) {
    const action = item.isEnabled ? actions.disable : actions.enable;

    return (
        <div className="u-display--flex u-display--flex--ai--center u-gap--tny">
            {item.sourceUrl && (
                <a
                    className="c-btn c-btn--sml c-btn--ghost"
                    href={item.sourceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(event) => event.stopPropagation()}
                >
                    {t("ADMINISTRATION.APP_RELEASE.ACTIONS.DOWNLOAD")}
                </a>
            )}
            <button
                type="button"
                className="c-btn c-btn--sml c-btn--ghost"
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    action.onClick(item);
                }}
            >
                {t(action.label)}
            </button>
        </div>
    );
}

function AppReleaseVersionsTemplate({ appReleaseViewStore, t }) {
    const { gridStore, queryUtility, latestVersion } = appReleaseViewStore;

    return (
        <React.Fragment>
            <MrbPageContentHeader classNameOverride="u-mar--bottom--sml">
                <AppReleaseLatestVersionTemplate latestVersion={latestVersion} t={t} />
                <MrbQuerySearchInput
                    queryUtility={queryUtility}
                    placeholder={t("ADMINISTRATION.APP_RELEASE.SEARCH_PLACEHOLDER")}
                />
            </MrbPageContentHeader>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
                ActionsComponent={AppReleaseRowActions}
            />
        </React.Fragment>
    );
}

AppReleaseVersionsTemplate.propTypes = {
    appReleaseViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default observer(AppReleaseVersionsTemplate);
